import { Flex, List, Typography } from 'antd';
import dayjs from 'dayjs';
import { Slot } from '../../../dto/model';
import { strings } from '../../../lang';

type PreSalesBookingSuccessProps = {
  bookedSlot: Slot;
  title: string;
};

export const PreSalesBookingSuccess = ({
  bookedSlot,
  title,
}: PreSalesBookingSuccessProps) => {
  const startDate = dayjs(bookedSlot.startDate).tz('Europe/Berlin');
  const details = [
    { label: strings.date, value: startDate.format('ddd, DD.MM.YYYY') },
    { label: strings.startTime, value: startDate.format('HH:mm') },
    { label: strings.salesManager, value: bookedSlot.salesManagerName },
    { label: strings.preSalesQuestionnaire.meetingUrlLabel, value: bookedSlot.meetingUrl },
    { label: strings.preSalesQuestionnaire.bookingIdLabel, value: bookedSlot.externalId },
  ].filter(({ value }) => Boolean(value));

  return (
    <Flex vertical gap={8}>
      <Typography.Title level={4} style={{ margin: 0 }}>
        {title}
      </Typography.Title>
      <List
        size="small"
        dataSource={details}
        renderItem={({ label, value }) => (
          <List.Item>
            <Typography.Text>
              {label}: <Typography.Text strong>{value}</Typography.Text>
            </Typography.Text>
          </List.Item>
        )}
      />
    </Flex>
  );
};
